import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Navigation Component
 * Provides navigation between chat and support dashboard
 */
const Navigation = () => {
  return (
    <nav className="app-navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <h2>Boris Sales Bot</h2>
        </div>
        <div className="nav-links">
          <NavLink
            to="/"
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            end
          >
            💬 Chat
          </NavLink>
          <NavLink
            to="/support"
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            🎫 Support Dashboard
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
